import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requiredRole }) {
  const { isAuthenticated, isLoading, user, isAdmin, isOperator } = useAuth();
  const location = useLocation();

  // [INTEGRATION FIX] Check localStorage directly.
  // This is the "Backup Check" that stops the redirect loop when you refresh the page.
  const hasToken = !!localStorage.getItem("tau_token");

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // [LOGIC UPDATE]
  // Only redirect to Login if BOTH the Context (isAuthenticated) AND the Browser (hasToken) say "No User".
  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role-based access control (Your original logic)
  if (requiredRole === "admin" && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredRole === "operator" && !isOperator()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}